import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SenaceService } from 'src/app/services/senace.service';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IDatosProyectoDatosGeneralesConsultora, IDatosProyectoDatosGeneralesRepresentante, IDatosProyectoDatosGeneralesTitular, IInformeITS, IDatosProfesionalesConsultora } from 'src/app/interface/interfaces';
import { VirtualTimeScheduler } from 'rxjs';
// import { DatosGeneralesService } from 'src/app/services/class/datos-generales.service';



@Component({
  selector: 'app-datos-generales',
  templateUrl: './datos-generales.component.html',
  styleUrls: ['./datos-generales.component.css']
})
export class DatosGeneralesComponent implements OnInit {
  titular: IDatosProyectoDatosGeneralesTitular = {};
  representante: IDatosProyectoDatosGeneralesRepresentante = {};
  consultora: IDatosProyectoDatosGeneralesConsultora = {};
  profesionales: IDatosProfesionalesConsultora = {};

  datosCertificacion = {
    unidadMinera: '', tipoProyecto: '',
    montoIntersion: '', vidaUtil: '',
    situacion: '', justificacion: '',
    objetivos: '', categoria:'',tdr:'',
    especi:'', clasifica:'', moneda:''
  };
  informeITS: IInformeITS = {};

  siglaExpediente: any;


  cuencas = {
    titulo: 'CUENCA HIDROGRAFICA',
    cabecera: ['CODIGO', 'TIPO', 'NOMBRE'],
    filas: []
  };
  ubicacionGeografica = {
    titulo: 'UBICACION GEOGRAFICA',
    cabecera: ['DEPARTAMENTO', 'PROVINCIA', 'DISTRITO'],
    filas: []
  }
  concesionesMineras = {
    titulo: 'CONCESIONES/AUTORIZACIONES',
    cabecera: ['CODIGO', 'NOMBRE', 'TITULAR'],
    filas: []
  }

  profesional={
    titulo: 'PROFESIONALES DE LA CONSULTORA',
    cabecera: ['DOCUMENTO','NOMBRE','PROFESIÓN'],
    filas: []
  }

  nroExpediente?: any;

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) {
    this.localStorage.getItem('detalle').subscribe(
      (resp: any) => {
        // console.log(resp);
        this.siglaExpediente = resp.correlativo.split('-')[1];

        this.nroExpediente = resp.correlativo;
        let datos: any;
        this.setDatosGenerales(resp);

        datos = this.senaceService.getProfesionales(resp);
        this.setProfesionales(datos);

        datos = this.senaceService.getUbicacion(resp);
        this.setUbicacion(datos);

        datos = this.senaceService.getCuenca(resp);
        this.setCuenca(datos);

        datos = this.senaceService.getConcesionesMineras(resp);
        this.setConcesionesMineras(datos);

        datos = this.senaceService.getDatosGeneralesCertificacion(resp);
        this.setDatosGeneralesCertificacion(datos, resp);

        // Objetivo ITS
        datos = this.senaceService.getObjetivoITS(resp);
        this.setObjetivoITS(datos);

        

        // console.log('cod_______', this.siglaExpediente);

        this.setVidaUtil(resp);
      }
    )
  }
  ngOnInit() {

  }

  setDatosGenerales(resultado) {
    let dato: any;
    if (resultado.solicitud) {
      for (const keySolicitud in resultado.solicitud) {
        if (keySolicitud === 'secciones') {
          for (const keySeccion in resultado.solicitud.secciones) {
            let secciones = resultado.solicitud.secciones[keySeccion];
            for (const keyCapitulos in secciones) {
              if (keyCapitulos === 'capitulos') {
                let capitulos = secciones['capitulos'];
                for (const keyDatos in capitulos) {
                  let datos = capitulos[keyDatos];
                  // console.log('dddd', datos);

                  if(datos['nombre']){
                    if(datos['nombre'].includes('Datos del Titular')){
                       if(datos['datos'].nombreTitular) this.titular.nombreTitular = datos['datos'].nombreTitular;
                       if(datos['datos'].ruc) this.titular.ruc = datos['datos'].ruc;
                       if(datos['datos'].telefono) this.titular.telefono = datos['datos'].telefono;
                    }

                    if(datos['nombre'].includes('Empresa Consultora')){
                       if(datos['datos'].nombreRazon) this.consultora.nombreRazon = datos['datos'].nombreRazon;
                       if(datos['datos'].ruc) this.consultora.ruc = datos['datos'].ruc;
                    }
                  }



                  for (const keySubDatos in datos['datos']) {

                    

                    //  CASO1 
                    if (keySubDatos === ' datosTitular ') {
                      dato = datos['datos'][' datosTitular '][0];
                      this.titular.nombreTitular = dato.nombreTitular;
                      this.titular.direccion = dato.direccion;
                      this.titular.ruc = dato.ruc;
                      this.titular.telefono = dato.telefono;
                    }
                    if (keySubDatos === 'representante') {
                      dato = datos['datos']['representante'][0];
                      dato = dato.representante;
                      if (dato) {
                        dato = dato.split('-');
                        this.representante.nombre = dato[1];
                        this.representante.dni = dato[0];
                      }
                    }
                    if (keySubDatos === 'consultora') {
                      dato = datos['datos']['consultora'][0];
                      this.consultora.domicilioLegal = dato.domicilio;                      
                      this.consultora.nombreRazon = dato.nombre;
                      this.consultora.numeroRegistroMINAM = dato.numeroRegistro;
                      this.consultora.ruc = dato.ruc;
                      this.consultora.telefono = dato.telefono;
                      this.consultora.email = dato.email;
                    }

                    // CASO 2
                    if (
                      datos['datos'].nombreTitular &&
                      datos['datos'].ruc &&
                      datos['datos'].direccion &&
                      datos['datos'].telefono) {
                      this.titular.nombreTitular = datos['datos'].nombreTitular;
                      this.titular.direccion = datos['datos'].direccion;
                      this.titular.telefono = datos['datos'].telefono;
                      this.titular.ruc = datos['datos'].ruc;
                    }
                    if (datos['datos'].representanteLegal) {
                      dato = datos['datos'].representanteLegal;
                      dato = dato.split('-');
                      this.representante.nombre = dato[1];
                      this.representante.dni = dato[0];
                    }
                    if (
                      datos['datos'].nombreRazon &&
                      datos['datos'].ruc &&
                      datos['datos'].domicilioLegal &&
                      datos['datos'].numeroRegistroMINAM &&
                      datos['datos'].telefono &&
                      datos['datos'].email
                    ) {
                      this.consultora.nombreRazon = datos['datos'].nombreRazon;
                      this.consultora.domicilioLegal = datos['datos'].domicilioLegal;
                      this.consultora.numeroRegistroMINAM = datos['datos'].numeroRegistroMINAM;
                      this.consultora.ruc = datos['datos'].ruc;
                      this.consultora.telefono = datos['datos'].telefono;
                      this.consultora.email = datos['datos'].email;
                    }

                    if (
                      datos['datos'].nombreRazon &&
                      datos['datos'].ruc &&
                      datos['datos'].domicilioLegal &&
                      datos['datos'].numeroRegistroConsultora &&
                      datos['datos'].telefono &&
                      datos['datos'].email
                    ) {
                      this.consultora.nombreRazon = datos['datos'].nombreRazon;
                      this.consultora.domicilioLegal = datos['datos'].domicilioLegal;
                      this.consultora.numeroRegistroMINAM = datos['datos'].numeroRegistroConsultora;
                      this.consultora.ruc = datos['datos'].ruc;
                      this.consultora.telefono = datos['datos'].telefono;
                      this.consultora.email = datos['datos'].email;
                    }

                    // CASO 3
                    if (
                      datos['datos'].nombre &&
                      datos['datos'].ruc &&
                      datos['datos'].direccion &&
                      datos['datos'].telefono) {
                      this.titular.nombreTitular = datos['datos'].nombre;
                      this.titular.direccion = datos['datos'].direccion;
                      this.titular.telefono = datos['datos'].telefono;
                      this.titular.ruc = datos['datos'].ruc;
                    }
                    if (
                      datos['datos'].nombre &&
                      datos['datos'].ruc &&
                      datos['datos'].domicilio &&
                      datos['datos'].numeroregistro &&
                      datos['datos'].telefono &&
                      datos['datos'].email
                    ) {
                      this.consultora.nombreRazon = datos['datos'].nombre;
                      this.consultora.domicilioLegal = datos['datos'].domicilio;
                      this.consultora.ruc = datos['datos'].ruc;
                      this.consultora.numeroRegistroMINAM = datos['datos'].numeroregistro;
                      this.consultora.telefono = datos['datos'].telefono;
                      this.consultora.email = datos['datos'].email;
                    }


                  }
                }
              }
            }
          }
        }
      }
    }

    // Mostrar información del nodo principal
    if (!this.titular.nombreTitular) {
      this.titular.nombreTitular = resultado.empresa;
      this.titular.ruc = resultado.ruc;
      this.titular.telefono = resultado.telefono;
      this.titular.direccion = resultado.direccion;
    }
  }

  setProfesionales(resultado){
    if (!resultado) return; 
    let data: any[] = resultado;
    if (data) {
      data.forEach(item => {
        let arr: any[] = [];
        if(item.profesionales){
          item.profesionales.forEach(items => {
            arr = [items.numeroDocumento || '', items.nombre || '', items.profesion || ''];
            this.profesional.filas.push(...[arr]);
          });
        }
        else{
          arr = [item.numeroDocumento || '', item.nombre || '', item.profesion || ''];
          this.profesional.filas.push(...[arr]);
        }
      });
    }
  }

  setUbicacion(resultado) {
    if (!resultado) return;
    let data: any[] = resultado['ubicacion']['localizacion'];
    if (data) {
      data.forEach(item => {
        let arr = [item.departamento || '', item.provincia || '', item.distrito || ''];
        this.ubicacionGeografica.filas.push(...[arr]);
      });
    }
  }
  setCuenca(resultado) {
    if (!resultado) return;
    let data: any[] = resultado['cuencas'];
    if (data) {
      data.forEach(item => {
        let arr = [item.codigo || '', item.tipo || '', item.nombre || ''];
        this.cuencas.filas.push(...[arr]);
      });
    }
  }
  setConcesionesMineras(resultado) {
    if (resultado) {
      if (resultado['derechosConcesiones']) {
        let data: any[] = resultado['derechosConcesiones'];
        if (data) {
          data.forEach(item => {
            let arr = [item.codigo || '', item.nombre || '', item.titular || ''];
            this.concesionesMineras.filas.push(...[arr]);
          });
        }
      }
    }

  }
  setDatosGeneralesCertificacion(resultado, resp: any) {
    if (!resultado && !resp) return;


    if (resultado) {
      if (resultado.vidaUtil) {
        this.datosCertificacion.vidaUtil = resultado.vidaUtil;
      }
      if (resultado.situacionActualProyecto) {
        this.datosCertificacion.situacion = resultado.situacionActualProyecto;
      }
      if (resultado.justificacionProyecto) {
        this.datosCertificacion.justificacion = resultado.justificacionProyecto;
      }
      if (resultado.objetivosProyecto) {
        this.datosCertificacion.objetivos = resultado.objetivosProyecto;
      }
      if (resultado.montoInversion) {
        this.datosCertificacion.montoIntersion = `${resultado.tipoMoneda} ${resultado.montoInversion}`;
      }     
    }

    if (resp) {
      if (resp.estado) {
        this.datosCertificacion.situacion = resp.estado;
      }
      if (resp.unidadProyecto) {
        this.datosCertificacion.unidadMinera = resp.unidadProyecto;
      }
      if (resp.solicitud.unidadProyecto) {
        this.datosCertificacion.unidadMinera = resp.solicitud.unidadProyecto;
      }
      if (resp.solicitud.tiposProyectos) {
        let data: any[] = resp.solicitud.tiposProyectos;
        if (data) {
          data.forEach(item => {
            this.datosCertificacion.tipoProyecto =item.nombre;
          });
        }        
      }
      if (resp.solicitud.montoInversion) {
        this.datosCertificacion.montoIntersion = `${resp.solicitud.moneda} ${resp.solicitud.montoInversion}`;
      }
      if (resp.solicitud.objetivosEspecificos) {
        this.datosCertificacion.objetivos = resp.solicitud.objetivosEspecificos;
      }
      if(resp.solicitud.categoria){
        this.datosCertificacion.categoria = resp.solicitud.categoria;
      }
      if(resp.solicitud.clasificacionAnticipada){
        this.datosCertificacion.clasifica = "SI";
      }else{
        this.datosCertificacion.clasifica = "NO";
      }  
      
      if(resp.solicitud.tdrComunes){
        this.datosCertificacion.tdr = "SI";        
      } else {
        this.datosCertificacion.tdr = "NO";
      }

      if(resp.solicitud.tdrEspecifico){
        this.datosCertificacion.especi = "SI";        
      } else {
        this.datosCertificacion.especi = "NO"; 
      }
    }
  }
  setVidaUtil(resp:any){
    const data = this.senaceService.getVidaUtil(resp);
    // console.log(data);
    if(data){
      this.datosCertificacion.vidaUtil = data;
    }
  }

  setObjetivoITS(resultado) {
    if (resultado) {
      this.informeITS = resultado;
      if(this.siglaExpediente === 'ITS'){
        this.datosCertificacion.montoIntersion = `${this.informeITS.justificacionITS} ${this.informeITS.monto}`;
        this.datosCertificacion.justificacion = this.informeITS.objetivosEspecificos;
        this.datosCertificacion.objetivos = this.informeITS.objetivosITS;
      }
    }
  }



}
